import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'usdDisplayToNumber', standalone: true })
export class DisplayToNumberPipe implements PipeTransform {
  transform(value: string | null | undefined): number {
    if (value) {
      const num = value.split(' ')[1];
      return Number(num);
    }
    return Number(value);
  }
}
